import ResizeSimpleAction from "./ResizeSimpleAction";
import { Qualifier } from "../../internal/qualifier/Qualifier";
/**
 * @description Defines an advanced resize.
 * @extends Actions.Resize.ResizeSimpleAction
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */
class ResizeAdvancedAction extends ResizeSimpleAction {
    /**
     * @description Which part of the original image to include.
     * @param {Qualifiers.Gravity} gravity
     */
    gravity(gravity) {
        if (typeof gravity === "string") {
            return this.addQualifier(new Qualifier('g', gravity));
        }
        return this.addQualifier(gravity);
    }
}
export default ResizeAdvancedAction;
